
import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";

export default function CartProduct(props) {
  const { decreaseQuantity, increaseQuantity, removeProductFromCart } = useContext(CartContext);

  const { id, title, price, img, quantity } = props;

  return (
    <div className="cart-row">
      {/* ستون تصویر و نام محصول */}
      <div className="cart-item cart-column">
        <img
          className="cart-item-image"
          src={`/${img}`}
          alt={title}
          width="100"
          height="100"
        />
        <span className="cart-item-title">{title}</span>
      </div>

      {/* ستون قیمت */}
      <span className="cart-price cart-column">{price} تومان </span>

      {/* ستون تعداد و دکمه‌ها - با کادر outline */}
      <div className="cart-quantity cart-column">
        <div className="quantity-box">
          {/* دکمه حذف کامل 🗑️ */}
          <button
            className="quantity-btn trash-btn"
            type="button"
            onClick={() => removeProductFromCart(id)}
            title="Remove completely"
          >
            🗑️
          </button>

          {/* دکمه کم کردن - */}
          <button
            className="quantity-btn minus-btn"
            type="button"
            onClick={() => decreaseQuantity(id)}
            title="Decrease quantity"
          >
            -
          </button>

          {/* نمایش تعداد فعلی */}
          <span className="quantity-number">{quantity}</span>

          {/* دکمه زیاد کردن + */}
          <button
            className="quantity-btn plus-btn"
            type="button"
            onClick={() => increaseQuantity(id)}
            title="Increase quantity"
          >
            +
          </button>
        </div>
      </div>
    </div>
  );
}